//
// Module for the member direct broadcast messages edit view
//
rs.module("content/system/configuration/memberdirectbroadcastmessages/edit",

    [
        "controls/data/grid",
        "common/select-helper",
        "common/visibility"
    ],

    function (gridModule, selectHelper, visibility) {
        // initialize the module
        function initialize(jsSelectors, backendUrls, employerGridLrsApi, activeCodeValues) {
            var form = $.js(jsSelectors.form);
            var startDate = form.js(jsSelectors.startDate);
            var startTime = form.js(jsSelectors.startTime);
            var endDate = form.js(jsSelectors.endDate);
            var endTime = form.js(jsSelectors.endTime);
            var loginFlagSelector = form.js(jsSelectors.loginFlagSelector);
            var customAudienceFlag = form.js(jsSelectors.customAudienceFlag);
            var fundSelector = form.js(jsSelectors.fundSelector);
            var fundSelectHelper = selectHelper.getHelper(fundSelector);
            var memberStatusSelector = form.js(jsSelectors.memberStatusSelector);
            var memberStatusSelectHelper = selectHelper.getHelper(memberStatusSelector);
            var participantSelector = form.js(jsSelectors.participantSelector);
            var participantSelectHelper = selectHelper.getHelper(participantSelector);
            var planSelector = form.js(jsSelectors.planSelector);
            var planSelectHelper = selectHelper.getHelper(planSelector);
            var warningContainer = form.js(jsSelectors.warningContainer);
            var audienceContainer = form.js(jsSelectors.audienceContainer);
            var employerGridContainer = form.js(jsSelectors.employerGridContainer);
            var planContainer = form.js(jsSelectors.planContainer);

            startDate.change(function () {
                if (!startDate.val()) {
                    startTime.val(null);
                }
                else if (!startTime.val()) {
                    startTime.val("00:00:00")
                }
            });

            endDate.change(function () {
                if (!endDate.val()) {
                    endTime.val(null);
                }
                else if (!endTime.val()) {
                    endTime.val("23:59:00")
                }
            });

            fundSelector.change(updatePlansAndEmployers);

            // update the plans and employers controls with new data 
            function updatePlansAndEmployers() {
                // populate employers on fund change
                gridModule.update(
                    backendUrls.getAvailableEmployers,
                    {
                        fundKey: $(fundSelector).val()
                    },
                    employerGridLrsApi.agGridApi,
                    function done() { }
                );

                // populate plans on fund change
                planSelectHelper.loadOptionsFrom(
                    backendUrls.getAvailablePlans,
                    {
                        fundKey: $(fundSelector).val()
                    });
            }

            loginFlagSelector.change(function () {
                var preLoginFlag = !(loginFlagSelector.val() == "False");
                $(customAudienceFlag).prop("disabled", preLoginFlag);
                fundSelectHelper.setDisabled(preLoginFlag);
                if (preLoginFlag) {
                    $(customAudienceFlag).setChecked(false);
                    customAudienceChanged();
                    fundSelectHelper.setValue(null);
                }
            });

            customAudienceFlag.change(customAudienceChanged);

            // set the visibility of controls based on the custom audience flag
            function customAudienceChanged() {
                var customAudience = $(this).prop("checked");                
                visibility.setVisible(warningContainer, !customAudience);
                visibility.setVisible(audienceContainer, customAudience);
                if (!customAudience) {
                    //clear custom audience controls
                    memberStatusSelectHelper.setValue("");
                    participantSelectHelper.setValue("");
                    planSelectHelper.setValue("");
                    employerGridLrsApi.selectedValues = null;
                    visibility.hide(planContainer);
                    visibility.hide(employerGridContainer);
                }
            }

            memberStatusSelector.change(function () {
                var activeStatusSelected = Object.values(activeCodeValues).some(status => memberStatusSelector.val().includes(status.toString()));                
                visibility.setVisible(planContainer, activeStatusSelected);
                visibility.setVisible(employerGridContainer, activeStatusSelected);

                if (!activeStatusSelected) {
                    planSelectHelper.setValue("");
                    employerGridLrsApi.selectedValues = null;
                }
                else if (employerGridLrsApi.selectedRows.length == 0) {
                    updatePlansAndEmployers();
                }
            });
        }
        
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);